// Single post template: "Copy link" pill, FAQ accordion, and an audio-plugin button skin (its
// shadow-DOM markup can't be reached by regular theme CSS).
export default function initSinglePost() {
  const root = document.querySelector('.klik-single-post');
  if (!root) return;

  initCopyLink(root);
  initAudioButtonSkin(root);
}

// --- Copy link -------------------------------------------------------------
function initCopyLink(root) {
  const button = root.querySelector('.klik-single-post__copy-link');
  if (!button) return;

  const label = button.querySelector('.klik-single-post__copy-link-label');
  const labelDefault = button.getAttribute('data-label-default') || (label ? label.textContent : 'Copy link');
  const labelCopied = button.getAttribute('data-label-copied') || 'Link copied';

  button.addEventListener('click', async () => {
    const url = button.getAttribute('data-copy-url') || window.location.href;

    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const input = document.createElement('input');
        input.value = url;
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
      }
    } catch (e) {
      return; // clipboard denied — leave the button as-is, no crash.
    }

    if (label) label.textContent = labelCopied;
    button.classList.add('is-copied');
    window.clearTimeout(button._klikCopyTimeout);
    button._klikCopyTimeout = window.setTimeout(() => {
      button.classList.remove('is-copied');
      if (label) label.textContent = labelDefault;
    }, 2000);
  });
}

// --- FAQ accordion: moved to components/faq.js (initFaqAccordions), which
// binds every .klik-faq-item on the page — including this template's.

// --- Audio plugin button skin (shadow DOM) ------------------------------
function initAudioButtonSkin(root) {
  const host = root.querySelector('.klik-single-post__audio-btn tts-play-button');
  if (!host) return;

  function applySkin() {
    if (!host.shadowRoot || host.shadowRoot.querySelector('style[data-klik-skin]')) return;

    const style = document.createElement('style');
    style.setAttribute('data-klik-skin', '');
    style.textContent = `
      /* Makes the shadow-root's own button/icon an invisible full-size overlay
         over our host-drawn icon; !important beats the plugin's ID-selector rule. */
      .wrapper,
      button,
      [id^="tts__listent_content_"] {
        all: unset !important;
        display: block !important;
        position: absolute !important;
        inset: 0 !important;
        width: 100% !important;
        height: 100% !important;
        margin: 0 !important;
        background: transparent !important;
        cursor: pointer !important;
      }
      svg, span { display: none !important; }
    `;
    host.shadowRoot.appendChild(style);
  }

  // The custom element may upgrade/attach its shadow root asynchronously —
  // try immediately, then keep watching briefly in case it isn't ready yet.
  applySkin();
  const observer = new MutationObserver(applySkin);
  observer.observe(host, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 5000);

  // The plugin's button swaps its aria-label between listen/pause states —
  // mirror that onto the host as `.is-playing` so CSS can swap the drawn icon.
  function syncPlayingState() {
    const innerBtn = host.querySelector('[id^="tts__listent_content_"]');
    if (!innerBtn) return;
    const isPlaying = /pause/i.test(innerBtn.getAttribute('aria-label') || '');
    host.classList.toggle('is-playing', isPlaying);
  }

  syncPlayingState();
  const stateObserver = new MutationObserver(syncPlayingState);
  stateObserver.observe(host, {
    // childList is required too: the plugin can swap in a whole new button
    // node instead of mutating the existing one's aria-label in place.
    attributes: true,
    attributeFilter: ['aria-label', 'title'],
    childList: true,
    subtree: true,
  });

  // Belt-and-braces: the plugin's click handler runs asynchronously, so
  // also re-check shortly after every click in case observers miss it.
  host.addEventListener('click', () => {
    window.setTimeout(syncPlayingState, 50);
    window.setTimeout(syncPlayingState, 300);
    window.setTimeout(syncPlayingState, 1000);
  });
}
